import { default as deepEqual } from 'fast-deep-equal'

export { deepEqual }
